import styled, { css } from "styled-components";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Estilos de Users
Description : Se definen los estilos de los elementos de la pantalla Users.
Date Autor Modification
================================================================================
23/10/2021 Cristian Andres Pizo Mina – Se defienen elementos y estilos del formulario.
================================================================================ */

export const H2 = styled.h2`
      font: 33px sans-serif;
  margin-top: 30px;
  text-align: center;
  position: relative;
  z-index: 1;
  &:before {
    border-top: 1px solid #1061a2;
  content: "";
  margin: 0 auto;
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  bottom: 0;
  width: 75%;
  z-index: -1;
    } 
`;
export const Span = styled.span`
     background: #fff;
  padding: 0 15px;
`;
export const Div_add = styled.div`
     width: 100%;
`;

export const Btn_add = styled.button`
    float:right; 
    /* margin-bottom: 20px;
    background-color:#0d6efd;   
    border-color:#0d6efd;
    color: white;
    padding: 10px 22px;
    border-radius: 7px; */
    background: transparent;
    color: #0099CC;
    border: 2px solid #0099CC;
    border-radius: 6px;
    &:hover {
        background-color:#0d6efd;
        color: white;
    } 
`;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    font-family: "Calibri";
    justify-content: center;
    padding: 2rem 5rem;
    width: 100%;
    font-family: sans-serif;
`;

export const Table = styled.table`
    /* border-spacing: 0;
    border: 1px solid #d1cccc; */
    border-collapse: collapse;
  margin: 25px 0;
  font-size: 0.9em;
  min-width: 400px;
  border-radius: 5px 5px 0 0;
  overflow: hidden;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
`;

export const Th = styled.th`
    margin: 0;
    padding: 0.5rem;
    border-bottom: 1px solid #d1cccc;
    border-right: 1px solid #d1cccc;
    &:last-child {
        border-right: 0;
    }    
`;
export const Td = styled.td`
    margin: 0;
    padding: 0.5rem;
    border-bottom: 1px solid #d1cccc;
    border-right: 1px solid #d1cccc;
    border-bottom: 0;
    &:last-child {
        border-right: 0;
    }   
`;
export const Pagination = styled.div`
    margin-top: 1.5rem;
    display: flex;
    justify-content: space-between;
`;
export const Page_controller = styled.div`
    width: 20px;
    height: 17px;
    display: flex;
`;
export const  Selecte = styled.select`
    border: 1px solid #d1cccc;
    border-radius: 0.2rem;
`;
 export const Tr = styled.tr`
    /* &:last-child {
        border-bottom: 0;
    }
    &:nth-child(odd){
        background: #f3f3f3;
        color: #000000;
    }
    &:nth-child(even){
        background: #ffffff;
        color: #000000;
    } */
 `;

export const Input = styled.input`
    padding: 0.5em;
    border-radius: 3px;
    width:100%;
    margin-bottom: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
`;
export const LabelField = styled.label`
	/* color: #3498DB; */
    display: block;
    /* margin-top: -5px; */
    float: left;
    /* margin-bottom: px; */
    margin-top: 5px;
    width: 100%;
`;
export const Title_modal = styled.h1`
	font-size: 30px;
`;
export const Modal_header = styled.div`
    text-align: center;
    width: 100%;
`;
export const Thead = styled.thead`
    background-color: #1061a2;
    color: #ffffff;
    font-weight: bold;
`;
